import React from "react";

function About() {
  return (
    <div>
      <h1 className="mx-5">
        Zen Class is one stop for all web developement education.
      </h1>

      <div className="container-home">
        <div className="container-home-left my-5">
          <p className="my-5 text-white">
            Tech is transforming every industry, and quality developers are
            going to be the driving force behind that change. Existing ways of
            developing talent through video based learning and traditional
            universities are not making the cut. We believe developers need and
            deserve better ways to learn and shape the new world.
          </p>
          <p className="my-5 text-white">
            Existing ways available to learn full stack development through
            video-based courses and expensive bootcamps aren't as effective when
            it comes to solving real-world tech problems. Recruiters too, look
            for real full stack development project experience when hiring
            developers and here at Zen class, we strive to provide just that. We
            empower developers with high quality applied learning opportunities
            and build skills that translate into career growth and success.
          </p>

          <p className="my-5 text-white">
            Our mission is to empower developers with high quality applied
            learning opportunities at scale, and nurture the talent for the
            future. We are building a platform that would fundamentally change
            the way tech is learnt through our “work-like” Micro-Experiences.
            Zen class Micro-Experiences provide an environment optimised for
            learning, with real world problems curated from the industry.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
